import { AdministratorsTable, SectionHead } from '../../components';
import { GET_DEFAULT_GROUPS } from '@/common/actions/get';
import { DELETE_FROM_DEFAULT_GROUP } from '@/common/actions/delete';
import { SET_TO_DEFAULT_GROUP } from '@/common/actions/create';
import {
  activeTab,
  administratorsInstructionTypeForFilter,
  administratorsQueryParamsInitial,
  getVariables,
} from '../../store';
import { useTableQueryParams } from '../../store/useTableQueryParams';
import { ModalAddAdministrators } from '../../modals/ModalAddAdministrators';
import { useLazyQuery, useMutation } from '@apollo/client';
import { Box } from '@servicepipe/ui-components';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

export const AdministratorsView = ({ isShowTable }) => {
  const { id: partnerClientAccountId } = useParams();
  const { queryParams, onPageChange, onSortingChange, onFiltersChange } = useTableQueryParams(
    administratorsQueryParamsInitial
  );
  const [isAddAdmin, setIsAddAdmin] = useState(false);

  const [getDefaultGroupsData, { data, loading, refetch }] = useLazyQuery(GET_DEFAULT_GROUPS);

  const [deleteGroup] = useMutation(DELETE_FROM_DEFAULT_GROUP, {
    onCompleted: () => {
      toast.success('Success');
      refetch();
    },
    onError: (error) => toast.error(error.message),
  });

  const [addAdministrators] = useMutation(SET_TO_DEFAULT_GROUP, {
    onCompleted: () => {
      toast.success('Success');
      setIsAddAdmin(false);
      refetch();
    },
    onError: (error) => toast.error(error.message),
  });

  useEffect(() => {
    if (queryParams.tab !== activeTab.administrators || !partnerClientAccountId) {
      return;
    }

    const variables = getVariables(queryParams, administratorsInstructionTypeForFilter, {
      pageSizeKey: 'limit',
    });

    getDefaultGroupsData({
      variables: { ...variables, partnerClientAccountId: Number(partnerClientAccountId) },
    });
  }, [queryParams, partnerClientAccountId]);

  if (!isShowTable) {
    return null;
  }

  return (
    <Box direction="column" gap="30px">
      <SectionHead
        title="Administrators"
        buttonLabel="Add administrator"
        onButtonClick={() => setIsAddAdmin(true)}
      />

      {isAddAdmin && (
        <ModalAddAdministrators
          onToggle={() => setIsAddAdmin(false)}
          addAdminHandler={(selectedUsers) =>
            addAdministrators({
              variables: {
                partnerClientAccountEmployeeIds: selectedUsers,
                partnerClientAccountId: Number(partnerClientAccountId),
              },
            })
          }
        />
      )}

      <AdministratorsTable
        queryParams={queryParams}
        totalCount={data?.defaultGroups?.info?.totalCount || 0}
        onPageChange={onPageChange}
        onSortingChange={onSortingChange}
        onFiltersChange={onFiltersChange}
        data={data?.defaultGroups?.items || []}
        loading={loading}
        totalPages={data?.defaultGroups?.info?.totalPages || 1}
        deleteGroupHandler={(id) => deleteGroup({ variables: { id: Number(id) } })}
      />
    </Box>
  );
};

export default AdministratorsView;
